import { render, staticRenderFns } from "./EmailBestaetigen.vue?vue&type=template&id=6fc5af62&scoped=true"
import script from "./EmailBestaetigen.vue?vue&type=script&lang=js"
export * from "./EmailBestaetigen.vue?vue&type=script&lang=js"
import style0 from "./EmailBestaetigen.vue?vue&type=style&index=0&id=6fc5af62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc5af62",
  null
  
)

export default component.exports